import { getType, Reducer } from 'typesafe-actions'

import { withLoadingReducer } from '../../../redux/loading'

import { AccountNotificationsActions } from './actions'
import { AccountNotificationsState } from './types'

export const initialState: AccountNotificationsState = {
  data: [],
  page: 1,
  totalPages: 1,
  templates: [],
  stats: {
    unreadCount: 0
  }
}

export const reducer: Reducer<AccountNotificationsState, AccountNotificationsActions> = (
  state = initialState,
  action
): AccountNotificationsState => {
  switch (action.type) {
    case getType(AccountNotificationsActions.fetchNotifications): {
      return {
        ...state,
        page: action.payload.page
      }
    }
    case getType(AccountNotificationsActions.setNotifications): {
      return {
        ...state,
        data: action.payload.data,
        page: action.payload.page,
        totalPages: action.payload.totalPages
      }
    }
    case getType(AccountNotificationsActions.setNotificationTemplates): {
      return {
        ...state,
        templates: action.payload.data
      }
    }
    case getType(AccountNotificationsActions.setNotificationsStats): {
      return {
        ...state,
        stats: action.payload
      }
    }
    default:
      return state
  }
}

export const accountNotificationsReducer = withLoadingReducer(reducer, 'accountNotifications', initialState)
